/**
 * Etiqueta para autocompletes/listas: nombre (si existe) y marca · modelo · talle.
 */
export function formatProductoAutocompleteLabel(p) {
  if (!p || typeof p !== "object") return "";
  const nombre =
    p.nombre != null && String(p.nombre).trim() ? String(p.nombre).trim() : "";
  const marca =
    p.marca && p.marca.nombre != null && String(p.marca.nombre).trim()
      ? String(p.marca.nombre).trim()
      : "";
  const modelo =
    p.modelo && p.modelo.nombre != null && String(p.modelo.nombre).trim()
      ? String(p.modelo.nombre).trim()
      : "";
  const tamanio =
    p.tamanio && p.tamanio.tamanio != null && String(p.tamanio.tamanio).trim()
      ? String(p.tamanio.tamanio).trim()
      : "";
  const attrs = [marca, modelo, tamanio].filter(Boolean);
  const attrsStr = attrs.length ? attrs.join(" · ") : "";
  if (nombre && attrsStr) return `${nombre} — ${attrsStr}`;
  if (nombre) return nombre;
  if (attrsStr) return attrsStr;
  const cb =
    p.codigoBarras != null && String(p.codigoBarras).trim()
      ? String(p.codigoBarras).trim()
      : "";
  if (cb) return `Cód. ${cb}`;
  return p.id != null ? String(p.id) : "";
}
